import React from 'react';

import { EllipsisTooltip } from '@/components/ui/EllipsisTooltip';

// The minmax(0, 1fr) grid lets auto-layout tables shrink the cell below its content (min-content 0)
// while still preferring its full width (max-content), so text truncates only when space runs out.
export const CellWithTooltip = ({ children }: { children: React.ReactNode }) => (
    <div className="grid grid-cols-[minmax(0,1fr)]">
        <EllipsisTooltip disableChildPointerEvents={true}>{children}</EllipsisTooltip>
    </div>
);

export const HeaderWithTooltip = ({
    children,
    observeResize = false,
}: {
    children: React.ReactNode;
    observeResize?: boolean;
}) => (
    <EllipsisTooltip className="block min-w-0 flex-1" observeResize={observeResize}>
        {children}
    </EllipsisTooltip>
);
